<template>
  <div>
    <v-tooltip v-if="!isArchiving" location="bottom">
      <template #activator="{ props }">
        <v-btn
          v-bind="props"
          icon="$archive-box"
          density="comfortable"
          variant="text"
          @click="onArchiveWorkpackageClick"
        />
      </template>
      <span>{{ $t('actions.archive') }}</span>
    </v-tooltip>
    <v-progress-circular v-else indeterminate size="25" width="3" />
  </div>
</template>

<script>
import { capitalize } from 'lodash';
import { mapActions, mapState } from 'pinia';
import entities from '@enums/entities';

// Composables
import { useDayjs } from '@/composables/use-dayjs';

// Stores
import { useContextStore } from '@/stores/context';
import { useWorkpackagesStore } from '@/stores/workpackages';
import { useSnackbarStore } from '@/stores/snackbar';

export default {
  props: {
    workpackage: {
      required: true,
      type: Object,
    },
    entity: {
      type: String,
      required: false,
      default: '',
    },
  },
  setup() {
    const { dayjs } = useDayjs();

    return { dayjs };
  },
  data() {
    return {
      isArchiving: false,
      message: '',
      offset: null,
      pageSize: null,
    };
  },
  computed: {
    ...mapState(useWorkpackagesStore, ['archivedWorkpackagesCurrentPage', 'workpackages']),
    ...mapState(useContextStore, ['clientConfig']),
    disabled() {
      return !this.hasPermission(this.userPermissions.canArchiveWorkpackage);
    },
  },
  created() {
    this.message = this.$t(`notifications.archive${capitalize(this.entity)}`, {
      name: this.workpackage.name,
    });
    this.pageSize = this.clientConfig.archivedWorpackages.pageSize;
    this.offset = (this.archivedWorkpackagesCurrentPage - 1) * this.pageSize;
  },
  methods: {
    ...mapActions(useWorkpackagesStore, [
      'updateWorkpackage',
      'fetchArchivedWorkpackages',
      'setWorkpackageById',
      'deleteWorkpackageById',
      'deleteWorkpackageTemplateById',
    ]),
    ...mapActions(useSnackbarStore, ['showSuccess']),
    async onArchiveWorkpackageClick() {
      this.isArchiving = true;
      const updates = {
        archived: true,
        archiveDate: this.dayjs.utc().toDate(),
      };
      await this.updateWorkpackage({
        workpackageId: this.workpackage._id,
        updates,
        omitStoreUpdate: true,
      });
      await Promise.all([
        this.fetchArchivedWorkpackages({
          limit: this.pageSize,
          offset: this.offset,
          shouldGetTemplates: this.entity === entities.template,
        }),
      ]);
      if (this.entity === entities.template) {
        this.deleteWorkpackageTemplateById(this.workpackage._id);
      } else {
        this.deleteWorkpackageById(this.workpackage._id);
      }

      this.showSuccess(this.message);
    },
  },
};
</script>
